import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';

import { NgbModule, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { PipeModule } from 'app/shared/pipes/pipe.module';

//COMPONENTS
import { CustomizerComponent } from './customizer/customizer.component';
import { FooterComponent } from "./footer/footer.component";
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { NavbarComponent } from "./navbar/navbar.component";
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';
import { VerticalMenuComponent } from "./vertical-menu/vertical-menu.component";

//DIRECTIVES
import { RouterModule } from '@angular/router';
import { InputsReactModule } from './components/reactive-inputs/inputs-react.module';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { SidebarAnchorToggleDirective } from './directives/sidebar-anchor-toggle.directive';
import { SidebarDropdownDirective } from './directives/sidebar-dropdown.directive';
import { SidebarLinkDirective } from './directives/sidebar-link.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";
import { TopMenuAnchorToggleDirective } from './directives/topmenu-anchor-toggle.directive';
import { TopMenuDropdownDirective } from './directives/topmenu-dropdown.directive';
import { TopMenuLinkDirective } from './directives/topmenu-link.directive';
import { TopMenuDirective } from './directives/topmenu.directive';
import { HttpHandler } from './http/http-handler';
import { ScreenTitleComponent } from './components/screen/screen-title/screen-title.component';
import { ButtonFormActionComponent } from './components/buttons/button-form-action/button-form-action.component';
import { ButtonRouterComponent } from './components/buttons/button-router/button-router.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { PageTabsComponent } from './components/tabs/page-tabs.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { UploadArquivoComponent } from './components/upload/upload-arquivo.component';


@NgModule({
  exports: [
    CommonModule,
    ButtonFormActionComponent,
    ButtonRouterComponent,
    FooterComponent,
    NavbarComponent,
    ScreenTitleComponent,
    PageTabsComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    CustomizerComponent,
    NotificationSidebarComponent,
    ToggleFullscreenDirective,
    SidebarDirective,
    TopMenuDirective,
    NgbModule,
    TranslateModule,
    TooltipComponent,
    UploadArquivoComponent,
  ],
  imports: [
    NgxMaskDirective,
    NgScrollbarModule,
    CommonModule,
    NgbModule,
    RouterModule,
    TranslateModule,
    OverlayModule,
    InputsReactModule,
    PipeModule,
    NgbNav
  ],
  declarations: [
    FooterComponent,
    ButtonFormActionComponent,
    ButtonRouterComponent,
    NavbarComponent,
    VerticalMenuComponent,
    PageTabsComponent,
    ScreenTitleComponent,
    HorizontalMenuComponent,
    CustomizerComponent,
    NotificationSidebarComponent,
    ToggleFullscreenDirective,
    SidebarLinkDirective,
    SidebarDropdownDirective,
    SidebarAnchorToggleDirective,
    SidebarDirective,
    TopMenuLinkDirective,
    TopMenuDropdownDirective,
    TopMenuAnchorToggleDirective,
    TopMenuDirective,
    TooltipComponent,
    UploadArquivoComponent,
  ],
  providers: [
    HttpHandler,
    provideNgxMask()
  ]
})
export class SharedModule { }
